import { getStatusClasses, getStatusLabel } from './PayableSelection.helpers';
import { OptionItem } from './types';

interface Props {
  item: OptionItem;
  isActive: boolean;
  disabled?: boolean;
  onSelect: (item: OptionItem) => void;
}

const PayableSelectionItem = ({
  item,
  isActive,
  disabled = false,
  onSelect,
}: Props) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onSelect(item)}
      className={`
        w-full rounded-md border px-5 py-4 text-left transition-all duration-200
        ${
          isActive
            ? 'border-primary bg-primary text-white shadow-2'
            : 'border-stroke bg-white hover:border-primary hover:bg-gray-2 dark:border-strokedark dark:bg-boxdark dark:hover:bg-meta-4'
        }
        ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}
      `}
    >
      <div className="mb-4 flex items-center justify-between">
        <div>
          <p
            className={`text-xs font-medium ${
              isActive ? 'text-white/80' : 'text-body dark:text-bodydark2'
            }`}
          >
            Cuenta por pagar
          </p>

          <p
            className={`text-base font-semibold ${
              isActive ? 'text-white' : 'text-black dark:text-white'
            }`}
          >
            {item.number}
          </p>
        </div>

        <span
          className={`
            inline-flex rounded px-3 py-1 text-xs font-medium
            ${getStatusClasses(item.status, isActive)}
          `}
        >
          {getStatusLabel(item.status)}
        </span>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <div>
          <p
            className={`text-xs ${
              isActive ? 'text-white/70' : 'text-body dark:text-bodydark2'
            }`}
          >
            Fecha emisión
          </p>

          <p
            className={`font-medium ${
              isActive ? 'text-white' : 'text-black dark:text-white'
            }`}
          >
            {item.issueDate}
          </p>
        </div>

        <div>
          <p
            className={`text-xs ${
              isActive ? 'text-white/70' : 'text-body dark:text-bodydark2'
            }`}
          >
            Fecha vencimiento
          </p>

          <p
            className={`font-medium ${
              isActive ? 'text-white' : 'text-black dark:text-white'
            }`}
          >
            {item.dueDate}
          </p>
        </div>

        <div>
          <p
            className={`text-xs ${
              isActive ? 'text-white/70' : 'text-body dark:text-bodydark2'
            }`}
          >
            Total
          </p>

          <p
            className={`font-semibold ${
              isActive ? 'text-white' : 'text-success'
            }`}
          >
            ${item.totalAmount.toFixed(2)}
          </p>
        </div>

        <div>
          <p
            className={`text-xs ${
              isActive ? 'text-white/70' : 'text-body dark:text-bodydark2'
            }`}
          >
            Saldo pendiente
          </p>

          <p
            className={`font-semibold ${
              isActive ? 'text-white' : 'text-danger'
            }`}
          >
            ${item.balance.toFixed(2)}
          </p>
        </div>
      </div>

      <div
        className={`mt-4 flex flex-wrap items-center justify-between gap-2 border-t pt-4 ${
          isActive ? 'border-white/20' : 'border-stroke dark:border-strokedark'
        }`}
      >
        <span
          className={`text-sm ${
            isActive ? 'text-white/90' : 'text-body dark:text-bodydark'
          }`}
        >
          Pagado: ${item.paidAmount.toFixed(2)}
        </span>

        {item.daysOverdue > 0 && (
          <span
            className={`
              inline-flex rounded px-3 py-1 text-xs font-medium
              ${
                isActive
                  ? 'bg-white/20 text-white'
                  : 'bg-danger bg-opacity-10 text-danger'
              }
            `}
          >
            {item.daysOverdue} días vencido
          </span>
        )}
      </div>
    </button>
  );
};

export default PayableSelectionItem;
